<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="manualDeliveryLabel"
    aria-hidden="true"
  >
    <div
      class="
        modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable
      "
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ $t("order.createManualDelivery") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row custom-input whitebg-input">
            <div class="col-md-4 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("order.width")
              }}</label>
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  v-model="form.width"
                />
                <span>cm</span>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("order.height")
              }}</label>
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  v-model="form.height"
                />
                <span>cm</span>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("order.length")
              }}</label>
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  v-model="form.length"
                />
                <span>cm</span>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("order.weight")
              }}</label>
              <div class="fix-end-input">
                <input
                  type="number"
                  step="1"
                  class="form-control"
                  v-model="form.weight"
                />
                <span>g</span>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("orderChange.value")
              }}</label>
              <div class="fix-end-input">
                <input
                  type="number"
                  step="0.01"
                  class="form-control"
                  v-model="form.value"
                />
                <span>{{ currency }}</span>
              </div>
            </div>
          </div>

          <hr />

          <div class="row custom-input whitebg-input">
            <div class="col-12 mb-3">
              <label class="form-label bold-12 text-gray">{{
                $t("orderChange.country")
              }}</label>
              <v-select
                :options="countries"
                v-model="form.country_id"
                label="name"
                :reduce="(c) => c.id"
                append-to-body
              />
            </div>
            <div class="col-12 mb-3" v-if="form.country_id">
              <label class="form-label bold-12 text-gray">{{
                $t("order.deliveryMethod")
              }}</label>
              <v-select
                :options="
                  webshops
                    .find((e) => e.id === webshopId)
                    ?.deliveryMethods.filter(
                      (e) =>
                        e.supported_coutries.indexOf(
                          countries.find((f) => f.id === form.country_id)?.code
                        ) > -1 &&
                        e.countries.findIndex((f) => f === form.country_id) > -1
                    )
                "
                v-model="form.delivery_method_id"
                label="name"
                :reduce="(c) => c.id"
                append-to-body
              />
            </div>
          </div>
          <div class="row" v-if="form.delivery_method_id">
            <div class="col md-3" v-if="selectedDelivery?.type === 2">
              <label class="form-label bold-12 text-gray">{{
                $t("companies.postCode")
              }}</label>
              <input class="form-control" v-model="packagePointPostCode" />
            </div>
            <div
              class="col-auto md-3 mt-4 pt-3"
              v-if="selectedDelivery?.type === 2"
            >
              <button class="btn btn-primary" v-on:click="searchPackagePoints">
                Search
              </button>
            </div>
            <div class="col-12 md-3 mt-2" v-if="selectedDelivery?.type === 2">
              <v-select
                :options="packagePoints"
                v-model="form.package_point"
                :placeholder="$t(`newSale.selectPackagePoint`)"
                :filter="filterPackagePoint"
                :reduce="(c) => c.pointId"
                :getOptionKey="(c) => c.pointId"
                append-to-body
              >
                <template v-slot:selected-option="option">
                  <div class="row">
                    <div class="col">
                      <b>{{ option.name }}</b>
                    </div>
                    <div class="col-auto">
                      {{ option.openingTime }}
                    </div>
                    <div class="col-12">
                      {{ option.postCode }} {{ option.city }}
                      {{ option.street }}
                    </div>
                  </div>
                </template>
                <template v-slot:option="option">
                  <div class="row text-wrap">
                    <div class="col">
                      <b>{{ option.name }}</b>
                    </div>
                    <div class="col-auto">
                      {{ option.openingTime }}
                    </div>
                    <div class="col-12">
                      {{ option.postCode }} {{ option.city }}
                      {{ option.street }}
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
            <div
              class="col-md-6 mb-3"
              v-if="
                selectedDeliveryCountry?.need_post_code &&
                selectedDelivery?.type !== 2
              "
            >
              <label class="form-label bold-12 text-gray">{{
                $t("orderChange.postCode")
              }}</label>
              <input class="form-control" v-model="form.post_code" />
            </div>
            <div
              class="col-md-6 mb-3"
              v-if="
                selectedDeliveryCountry?.need_state &&
                selectedDelivery?.type !== 2
              "
            >
              <label class="form-label bold-12 text-gray">{{
                stateTypes[setNullToZero(selectedDeliveryCountry?.state_type)]
                  ?.name
              }}</label>
              <input class="form-control" v-model="form.state" />
            </div>
            <div class="col-md-6 mb-3" v-if="selectedDelivery?.type !== 2">
              <label class="form-label bold-12 text-gray">{{
                $t("orderChange.city")
              }}</label>
              <input class="form-control" v-model="form.city" />
            </div>
            <div class="col-8 mb-3" v-if="selectedDelivery?.type !== 2">
              <label class="form-label bold-12 text-gray">{{
                $t("order.address")
              }}</label>
              <input class="form-control" v-model="form.street" />
            </div>
            <div class="col-4 mb-3" v-if="selectedDelivery?.type !== 2">
              <label class="form-label bold-12 text-gray">{{
                $t("orderChange.number2")
              }}</label>
              <input class="form-control" v-model="form.house" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            {{ $t("orderChange.close") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="loading"
            v-on:click="submit"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {{ $t("order.createDelivery") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import http from "../../modules/http";
import StateTypes from "../../modules/StateTypes";

export default {
  name: "ManualDeliveryModal",
  props: {
    modelValue: Number,
    DefaultDelivery: Object,
    webshopId: {
      type: Number,
      default: () => 0,
    },
    currency: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      modal: null,
      webshops: [],
      countries: [],
      stateTypes: StateTypes,
      loading: false,
      packagePointPostCode: "",
      packagePoints: [],
      form: {
        width: null,
        height: null,
        length: null,
        weight: null,

        country_id: null,
        delivery_method_id: null,
        post_code: "",
        city: "",
        street: "",
        house: "",
        value: 0,
      },
    };
  },
  mounted() {
    this.modal = new Modal(this.$refs.modal);
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
    selectedWarehouse() {
      return this.warehouses.find((e) => e.id === this.warehouse);
    },
    selectedDelivery() {
      return this.webshops
        .find((e) => e.id === this.webshopId)
        ?.deliveryMethods?.find((e) => e.id === this.form?.delivery_method_id);
    },
    selectedDeliveryCountry() {
      return this.countries.find((e) => e.id === this.form?.country_id);
    },
  },
  methods: {
    setNullToZero(val) {
      if (val === null) {
        return 0;
      }
      return val;
    },
    showModal() {
      this.prefillData();
      this.modal.show();
    },
    prefillData() {
      if (this.countries.length === 0) {
        http.fetch("/countries/all").then((data) => {
          this.countries = data;
        });
      }
      if (this.webshops.length === 0) {
        http.fetch("/webshops").then((data) => {
          this.webshops = data;
        });
      }
      console.log(this.defaultDelivery);
      if (this.defaultDelivery !== undefined && this.defaultDelivery !== null) {
        this.form.country_id = this.defaultDelivery.country_id;
        this.form.city = this.defaultDelivery.city;
        this.form.post_code = this.defaultDelivery.post_code;
        this.form.street = this.defaultDelivery.street;
        this.form.house = this.defaultDelivery.house;
        this.form.state = this.defaultDelivery.state ?? null;
      }
    },
    searchPackagePoints() {
      this.packagePoints = [];
      http
        .fetch(
          "/deliveries/package-points/" +
            this.selectedDelivery.id +
            "/" +
            this.selectedDeliveryCountry.code +
            "/" +
            this.packagePointPostCode
        )
        .then((data) => {
          this.packagePoints = data.list;
        });
    },
    submit() {
      this.loading = true;
      http
        .fetch("/orders/delivery/manual", {
          order_id: this.modelValue,
          ...this.form,
        })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.modal.hide();
            this.$emit("refresh");
            this.$toast.success("Delivery label created successfully");
          } else {
            this.$toast.error(
              response.data.message || "Error creating delivery label"
            );
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(
            error.response?.data?.message || "Error creating delivery label"
          );
        });
    },
  },
};
</script>
